import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  content: {
    flex: 1,
    backgroundColor: white,
  },
  scrollIndicatorInsets: {
    right: 1,
  },
});
